import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChanges: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"changes, plus-minus, compare"} maskId="square-filled-radius-0-stroke-1-IconChanges"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.5 16V17H15.5V16H8.5ZM11.5 10H8.5V11H11.5V14H12.5V11H15.5V10H12.5V7H11.5V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChanges;
